
// src/services/apiService.js 
import apiClient from "./apiGateway";


export const getPayrollDetails = async (payload) => {
  const response = await apiClient.post(`/GetPayrolldetails`,payload);
  return response;
};

export const GetPayrolldetailsforreport = async (payload) => {
  const response = await apiClient.post(`/GetPayrolldetailsforreport`,payload);
  return response;
};

export const GetPayrollColumnsforReport = async (payload) => {
  const response = await apiClient.post(`/GetPayrollColumnsforReport`,payload);
  return response;
};

export const GetEmployeeWisePayslip = async (payload) => {
  const response = await apiClient.post(`/GetEmployeeWisePayslip`,payload);
  return response;
};


export const getMonthlyDetailedEmployeepayroll = async (payload) => {
  const response = await apiClient.post(`/getMonthlyDetailedEmployeepayroll`,payload);
  return response;
};

// dataservice.js
export const GetNextVoucherNumber = async () => {
  const response = await apiClient.get('/GetNextVoucherNumber');
  return response;
};

export const UpdateVoucherNumber = async (payload) => {
  
  const response = await apiClient.post(`/UpdateVoucherNumber`, payload);
  return response;
};

export const InsertAnnounceMents = async (payload) => {

  const response = await apiClient.post(`/insertAnnounceMents`, payload);
  return response;
};

export const getPunchRecords = async (payload) => {
  const response = await apiClient.post(`/getpunchrecords`,payload);
  return response;
};

export const getAnnouncement = async (payload) => {
  const response = await apiClient.post(`/getAnnouncement`,payload);
  return response;
};


export const UpdateAutheriseLeavetoLeave = async (payload) => {
  const response = await apiClient.post(`/UpdateAutheriseLeavetoLeave`,payload);
  return response;
};
export const UpdateLeaveandInsertRecord = async (payload) => {
  const response = await apiClient.post(`/UpdateLeaveandInsertRecord`,payload);
  return response;
};
export const UpdaterecordandInsertRecord = async (payload) => {
  const response = await apiClient.post(`/UpdaterecordandInsertRecord`,payload);
  return response;
};
export const InsertAutoDeduct = async (payload) => {
  const response = await apiClient.post(`/InsertAutoDeduct`,payload);
  return response;
};

export const insertCompanyLocation = async (payload) => {
  const response = await apiClient.post(`/insertCompanyLocation`,payload);
  return response;
};

export const recallleaverequest = async (payload) => {
  const response = await apiClient.post(`/recallleaverequest`,payload);
  return response;
};

//nissa api 
export const getShifEmployees = async (payload) => {
  const response = await apiClient.post(`/GetEmployeewithDepId`,payload);
  return response;
};

export const InsertDuty = async (payload) => {
  const response = await apiClient.post("/InsertDuty", payload);
  return response;
};

export const getLevelData = async () => {
  const response = await apiClient.get("/getlevelmaster");
  return response;
};


export const DeleteEmployee = async (payload) => {
  
  const response = await apiClient.post("/deleteEmployee", payload);
  return response;
};
export const GetPendingLeave = async (payload) => {
  const response = await apiClient.post("/getemployeeleaveadmin", payload);
  return response;
};

export const GetLastWeekOff = async (payload) => {
  const response = await apiClient.post("/GetLastWeekOff", payload);
  return response;
};

export const insertLevelMaster = async (payload) => {
  const response = await apiClient.post("/insertlevelmaster", payload);
  return response;
};


export const GetAttendanceReport = async (payload) => {
  const response = await apiClient.post("/GetAttendanceReport", payload);
  return response;
};


export const GetAttendanceReportMobilePunch = async (payload) => {
  const response = await apiClient.post("/GetAttendanceReportMobilePunch", payload);
  return response;
};


export const GetLateDeduction = async (payload) => {
  const response = await apiClient.post("/GetLateDeduction", payload);
  return response;
};

export const GetMusterRoll = async (payload) => {
  const response = await apiClient.post("/GetMusterRoll", payload);
  return response;
};

export const GetDynamicOptions = async (payload) => {
  const response = await apiClient.post("/getdynamicoptions", payload);
  return response;
};


export const InsertEmployeeFinanceDetails = async (payload) => {
  const response = await apiClient.post("/insertfinancedetails", payload);
  return response;
};

//=================================================
// User service functions
export const registerUser = async (payload) => {
  const response = await apiClient.post("/register", payload);
  return response;
};

export const sendemployeedeletionotp = async (payload) => {
  const response = await apiClient.post("/sendotpdeletionotp", payload);
  return response;
};

export const ResetUserPassWord = async (payload) => {
  const response = await apiClient.post("/getotpForUser", payload);
  return response;
}; 
export const VerifyUserOtp = async (payload) => {
  const response = await apiClient.post("/VerifyUserOtp", payload);
  return response;
};

export const UpdateUserPassWord = async (payload) => {
  const response = await apiClient.post("/UpdateUserPassWord", payload);
  return response;
};

export const loginUser = async (payload) => {
  const response = await apiClient.post("/login", payload);

  return response;
};
export const userWiseRight = async (query) => {
  const response = await apiClient.get(`/userwiseright?UserId=${query}`);
  return response;
};


export const getfinancedetails = async (EmpId) => {
  try {
    const response = await apiClient.get(`/getEmployeeFinance/${EmpId}`);
    return response.data; // Returning only the data
  } catch (error) {
    console.error("Error fetching employee finance details:", error);
    throw error;
  }
};



export const getAdditionDiductionType=async (query)=>{
  const response= await apiClient.get(`/getAdditionDiductionType?UserId=${query}`)
  return response;
}

export const getBanckName=async (query)=>{
  const response= await apiClient.get(`/getBanckName?UserId=${query}`)
  return response;
}

export const getLastLeaveResetYear=async (query)=>{
  const response= await apiClient.get(`/get-last-reset-year?UserId=${query}`)
  return response;
}



export const ResetEmployeeUpdatedLeave = async (userId) => {
  return await apiClient.post("/reset-employee-leave", { UserId: userId });
};


export const getcompanyLoginpage = async (query) => {
  const response = await apiClient.get(`/getcompanyLoginpage?UserId=${query}`);
  return response;
};

export const getCompanys = async (query) => {
  const response = await apiClient.get(`/getcompany?UserId=${query}`);
  return response;
};
export const getemloyeeforinsert = async (query) => {
  const response = await apiClient.get(`/getemloyeeforinsert?UserId=${query}`);
  return response;
};
// Departments
export const insertDepartments = async (payload) => {
  const response = await apiClient.post("/insertdepartments", payload);
  return response;
};
export const RevertDeduction = async (payload) => {
  const response = await apiClient.post("/RevertDeduction", payload);
  return response;
};



export const getDeductionWiseReport=async (payload)=>{
  const response= await apiClient.post("/getDeductionWiseReport",payload)
  return response;
}


export const InsertUnAutherisePayrollUserDetails = async (payload) => {
  const response = await apiClient.post("/InsertUnAutherisePayrollUserDetails", payload);
  return response;
};


export const getDepartments = async (query) => {
  const response = await apiClient.get(`/getdepartments?UserId=${query}`);
  return response;
};

export const getApprovaloptions = async (query) => {
  const response = await apiClient.get(`/getapprovaloptions?UserId=${query}`);
  return response;
};

export const deleteDepartments = async (payload, query) => {
  const response = await apiClient.post(`/deleterow?UserId=${query}`, payload);
  return response;
};

// category
export const insertCategory = async (payload) => {
  const response = await apiClient.post("/insertcategory", payload);
  return response;
};
export const getCategorys = async (query) => {
  const response = await apiClient.get(`/getcategory?UserId=${query}`);
  return response;
};

export const deleteCategorys = async (payload, query) => {
  const response = await apiClient.post(`/deleterow?UserId=${query}`, payload);
  return response;
};

// ProfitCenter

export const insertProfitCenters = async (payload) => {
  const response = await apiClient.post("/insertprofitcenter", payload);
  return response;
};

export const getProfitCenter = async (query) => {
  const response = await apiClient.get(`/getprofitcenter?UserId=${query}`);
  return response;
};

export const deleteProfitCenters = async (payload, query) => {
  const response = await apiClient.post(`/deleterow?UserId=${query}`, payload);
  return response;
};

// Group
export const insertGroup = async (payload) => {
  const response = await apiClient.post("/insertgroup", payload);
  return response; 
}; 

export const getGroup = async (query) => {
  const response = await apiClient.get(`/getgroup?UserId=${query}`);
  return response;
};

export const getCompanyLocation = async (query) => {
  const response = await apiClient.get(`/companyLocation?UserId=${query}`);
  return response;
};

export const GetLastTenLeaveAndPermissions = async (query) => {
  const response = await apiClient.get(`/GetLastTenLeaveAndPermissions?UserId=${query}`);
  return response;
};
// deleteGroups

export const deleteGroups = async (payload, query) => {
  const response = await apiClient.post(`/deleterow?UserId=${query}`, payload);
  return response;
};

// desigination

export const insertDesignation = async (payload) => {
  const response = await apiClient.post("/insertdesignation", payload);
  return response;
};
export const getDesignation = async (query) => {
  const response = await apiClient.get(`/getdesignation?UserId=${query}`);
  return response;
};
// delete

export const deleteDesignation = async (payload, query) => {
  const response = await apiClient.post(`/deleterow?UserId=${query}`, payload);
  return response;
};
// employee

export const insertEmployee = async (payload) => {
  const response = await apiClient.post("/insertemployee", payload);
  return response;
};
//download emp data
export const downloadEmployeeData = async (payload) => {
  const response = await apiClient.post("/GetEmployeewisefulldataforweb", payload);
  return response;
};

export const insertPerEmployee = async (payload) => {
  const response = await apiClient.post("/insertemployeedetails", payload);
  return response;
};
export const Insertbankdetails = async (payload) => {
  const response = await apiClient.post("/Insertbankdetails", payload);
  return response;
};
export const insertemployeedocuments = async (payload) => {
  const response = await apiClient.post("/insertemployeedocuments", payload);
  return response;
};

export const getEmployee = async (query) => {
  const response = await apiClient.get(`/GetEmployee?UserId=${query}`);

  return response;
};


export const getAllEmployee = async (query) => {
  const response = await apiClient.get(`/GetAllEmployee?UserId=${query}`);

  return response;
};
export const getDocumentsType = async (query) => {
  const response = await apiClient.get(`/GetDocType?UserId=${query}`);

  return response;
};
export const GetEmployeeDocuments = async (query) => {
  const response = await apiClient.get(`/GetEmployeeDocuments?UserId=${query}`);

  return response;
};

export const GetEmployeedetails = async (query) => {
  const response = await apiClient.get(`/GetEmployeedetails?UserId=${query}`);
  return response;
};
export const GetBankDetails = async (query) => {
  const response = await apiClient.get(`/GetBankDetails?UserId=${query}`);
  return response;
};

// employee-Type

export const insertEmployeeType = async (payload) => {
  const response = await apiClient.post("/insertemployetype", payload);
  return response;
};
export const getEmployeeType = async (query) => {
  const response = await apiClient.get(`/getemployeetype?UserId=${query}`);
  return response;
};
// delete

export const deleteEmployeeType = async (payload, query) => {
  const response = await apiClient.post(`/deleterow?UserId=${query}`, payload);
  return response;
};
// wages

export const insertWages = async (payload) => {
  const response = await apiClient.post("/insertWageComponent", payload);
  return response;
};

export const getWages = async (query) => {
  const response = await apiClient.get(`/getWageComponent?UserId=${query}`);
  return response;
};

// deleterow

export const deleteWages = async (payload, query) => {
  const response = await apiClient.post(`/deleterow?UserId=${query}`, payload);
  return response;
};

// wages-type

export const insertWageTypes = async (payload) => {
  const response = await apiClient.post("/insertwagetype", payload);
  return response;
};
export const GetDailyAttendanceSummary = async (payload) => {
  const response = await apiClient.post("/GetDailyAttendanceSummary", payload);
  return response;
};
export const getWageTypes = async (query) => {
  const response = await apiClient.get(`/getWageType?UserId=${query}`);
  return response;
};

// deletewage-type

export const deleteWageTypes = async (payload, query) => {
  const response = await apiClient.post(`/deleterow?UserId=${query}`, payload);
  return response;
};

// holiday

export const insertHoliday = async (payload) => {
  const response = await apiClient.post("/insertholiday", payload);
  return response;
};
export const getHoliday = async (query) => {
  const response = await apiClient.get(`/getholiday?UserId=${query}`);
  return response;
};

// deleteholiday

export const deleteholiday = async (payload, query) => {
  const response = await apiClient.post(`/deleterow?UserId=${query}`, payload);
  return response;
};

// shift

export const insertShift = async (payload) => {
  const response = await apiClient.post("/insertshift", payload);
  return response;
};

export const getShift = async (query) => {
  const response = await apiClient.get(`/getshift?UserId=${query}`);  
  return response;
};
export const getAutheriseOptions = async (isAdmin, departmentId) => {
  const response = await apiClient.get(`/getautheriseoptions`, {
    params: { IsAdmin: isAdmin, DepartmentId: departmentId }
  });
  return response;
};

export const UpdateRecordsFromAutherise = async (payload) => {
  const response = await apiClient.post("/updaterecordsfromautherise", payload);
  return response;
};

export const UpdateRecordsandleaveFromAutherise = async (payload) => {
  const response = await apiClient.post("/updaterecordsandleavefromautherise", payload);
  return response;
};




export const getRecordsForAutherise = async (payload) => {
  const response = await apiClient.post(`/getrecordsforautherise`,payload);  
  return response; 
};
export const getPunchData = async (payload) => {
  const response = await apiClient.post(`/getPunchData`,payload);  
  return response;
};

export const getLeaveGraph = async (payload) => {
  const response = await apiClient.post(`/getLeaveGraph`,payload);  
  return response;
};

export const getPuchesforEmployeeApk  =async (payload)=>{
  const response= await apiClient.post(`/getPuchesforEmployeeApk`)
}

// delete shift

export const deleteShift = async (payload, query) => {
  const response = await apiClient.post(`/deleterow?UserId=${query}`, payload);
  return response;
};

// payscale

export const insertPayscale = async (payload) => {
  const response = await apiClient.post("/insertPayscale", payload);
  return response;
};

export const getPayScale = async (query) => {
  const response = await apiClient.get(`/getpayScale?UserId=${query}`);
  return response;
};

// delete payscale

export const deletePayScales = async (payload, query) => {
  const response = await apiClient.post(`/deleterow?UserId=${query}`, payload);
  return response;
};

// AllowanceBonus

export const insertAllowancesBonuss = async (payload) => {
  const response = await apiClient.post("/insertallowancebonus", payload);
  return response;
};

export const getAllowancesBonuss = async (query) => {
  const response = await apiClient.get(`/getallowancebonus?UserId=${query}`);
  return response;
};

// delete allowancesBonus

export const deleteAllowancesBonuss = async (payload, query) => {
  const response = await apiClient.post(`/deleterow?UserId=${query}`, payload);
  return response;
};

// Provident Fund

export const insertProvidentFunds = async (payload) => {
  const response = await apiClient.post("/insertpfsetting", payload);
  return response;
};

export const getProvidentFunds = async (query) => {
  const response = await apiClient.get(`/getpfsetting?UserId=${query}`);
  return response;
};

// delete Provident Fund

export const deleteProvidentFunds = async (payload, query) => {
  const response = await apiClient.post(`/deleterow?UserId=${query}`, payload);
  return response;
};

// job Opening

export const insertJobOpenings = async (payload) => {
  const response = await apiClient.post("/insertjobopening", payload);
  return response;
};

export const getJobOpenings = async (query) => {
  const response = await apiClient.get(`/getjobopening?UserId=${query}`);
  return response;
};

export const deleteJobOpenings = async (payload, query) => {
  const response = await apiClient.post(`/deleterow?UserId=${query}`, payload);
  return response;
};

// payrole

export const insertPayroles = async (payload) => {
  const response = await apiClient.post("/insertwagestypes", payload);
  return response;
};

// payroles get

export const getPayRoleType = async (query) => {
  const response = await apiClient.get(`/getpayrole?UserId=${query}`);
  return response;
};

// payrole delete

export const deletePayRoleTypes = async (payload, query) => {
  const response = await apiClient.post(`/deleterow?UserId=${query}`, payload);
  return response;
};

// genders

export const insertGenders = async (payload) => {
  const response = await apiClient.post("/insertwagestypes", payload);
  return response;
};

// genders get

export const getGenders = async (query) => {
  const response = await apiClient.get(`/GetGender?UserId=${query}`);
  return response;
};

// genders delete

export const deleteGenders = async (payload, query) => {
  const response = await apiClient.post(`/deleterow?UserId=${query}`, payload);
  return response;
};

// employee docs
export const insertEmployeeDocss = async (payload) => {
  const response = await apiClient.post("/insertwagestypes", payload);
  return response;
};

// employee docs get

export const getEmployeeDocs = async (query) => {
  const response = await apiClient.get(`/getemployeeDocs?UserId=${query}`);
  return response;
};

// employee docs delete

export const deleteEmployeeDocs = async (payload, query) => {
  const response = await apiClient.post(`/deleterow?UserId=${query}`, payload);
  return response;
};

//User

export const insertUsers = async (payload) => {
  const response = await apiClient.post("/insertuser", payload);
  return response;
};

export const getUsers = async (query) => {
  const response = await apiClient.get(`/getusers?UserId=${query}`);
  return response;
};

// LEAVE

export const insertLeaves = async (payload) => {
  const response = await apiClient.post("/insertleave", payload);
  return response;
};

export const getLeaves = async (query) => {
  const response = await apiClient.get(`/getLeave?UserId=${query}`);
  return response;
};

// delete leave

export const deleteLeaves = async (payload, query) => {
  const response = await apiClient.post(`/deleterow?UserId=${query}`, payload);
  return response;
};

// SPECIAL OCCASION

export const insertSpecialOccassions = async (payload) => {
  const response = await apiClient.post("/insertSpecialOccation", payload);
  return response;
};

export const getSpecialOccassions = async (query) => {
  const response = await apiClient.get(`/Specialoccations?UserId=${query}`);
  return response;
};

// delete special occassion

export const deleteSpecialOccassions = async (payload, query) => {
  const response = await apiClient.post(`/deleterow?UserId=${query}`, payload);
  return response;
};

// LEAVE-type
export const insertLeaveTypes = async (payload) => {
  const response = await apiClient.post("/insertLeaveType", payload);
  return response;
};
export const getLeaveTypes = async (query) => {
  const response = await apiClient.get(`/getLeaveType?UserId=${query}`);
  return response;
};

export const GetOtherLeaves = async (query) => {
  const response = await apiClient.get(`/GetOtherLeaves?UserId=${query}`);
  return response;
};


export const getServiceBookTypes = async (query) => {
  const response = await apiClient.get(`/getServicebookType?UserId=${query}`);
  return response;
};
export const GetEmployeeServiceBooks = async ({ UserId, EmpId }) => {
  const response = await apiClient.get(`/GetEmployeeServiceBooks`, {
    params: { UserId, EmpId }
  });
  return response;
};
export const insertEmployeeServiceBook = async (query) => {
  const response = await apiClient.post(`/insertEmployeeServiceBook?UserId=${query}`);
  return response;
};

export const getallowancebonusType = async (query) => {
  const response = await apiClient.get(`/getallowancebonusType?UserId=${query}`);
  return response;
};



// delete leave-type

export const deleteLeaveTypes = async (payload, query) => {
  const response = await apiClient.post(`/deleterow?UserId=${query}`, payload);
  return response;
};

// pages

export const getPages = async (query) => {
  const response = await apiClient.get(`/getpages?UserId=${query}`);
  return response;
};

// User-role
export const insertUserRoles = async (payload) => {
  const response = await apiClient.post("/insertwagestypes", payload);
  return response;
};
// get

export const getUserRoles = async (query) => {
  const response = await apiClient.get(`/getUserRole?UserId=${query}`);
  return response;
};

// delete user-role

export const deleteUserRoles = async (payload, query) => {
  const response = await apiClient.post(`/deleterow?UserId=${query}`, payload);
  return response;
};
// userRole

export const insertUserRole = async (payload) => {
  const response = await apiClient.post("/insertUserRole", payload);
  return response;
};
// User-rights
export const insertUserRights = async (payload) => {
  const response = await apiClient.post("/insertuserrights", payload);
  return response;
};

// get

export const getUserRightss = async (query) => {
  const response = await apiClient.get(`/getUserRight?UserId=${query}`);
  return response;
};
// delete user-rights

// export const getEmployeeDocss = async (query) => {
//   const response = await apiClient.get(`/GetEmployeeDocuments=${query}`);
//   return response;
// };



export const deleteUserRightss = async (payload, query) => {
  const response = await apiClient.post(`/deleterow?UserId=${query}`, payload);
  return response;
};

//company
export const getComapanyId = async (payload) => {
  const response = await apiClient.post("/getcompanyid", payload);
  return response;
};





// delete company

export const deleteCompany = async (payload, query) => {
  const response = await apiClient.post(`/deleterow?UserId=${query}`, payload);
  return response;
};


//TranceActions

export const getAttendenceData = async (payload) => {
  const response = await apiClient.post("/GetRecordsForAttendanceWithDate", payload);
  return response;
};


export const getdutywithdate = async (payload) => {
  const response = await apiClient.post("/GetDutyWithDate", payload);
  return response;
};

export const getLastLoginDetails = async (payload) => {
  const response = await apiClient.post("/getLastLoginDetails", payload);
  return response;
};

export const getEmpLeaveRequest = async (payload) => {
  const response = await apiClient.post("/GetEmpLeaveRequest", payload);
  return response;
};

export const insertMarkAttendence = async (payload) => {
  const response = await apiClient.post("/MarkAttendance", payload);
  return response;
};

export const DeductHalfDayFromAttendance = async (payload) => {
  const response = await apiClient.post("/deductHalfDayfromattendance", payload);
  return response;
};

export const LateDeduct = async (payload) => {
  const response = await apiClient.post("/LateDeduct", payload);
  return response;
};

export const getemployeewithshift = async (payload) => {
  const response = await apiClient.post("/getemployeewithshift", payload);
  return response;
};

export const insetNewAttendence = async (payload) => {
  const response = await apiClient.post("/insertAttendance", payload);
  return response;
};
export const getusertype = async (payload) => {
  const response = await apiClient.post("/GetUserType", payload);
  return response;
};

export const GetNoOfLeaveWithDate = async (payload) => {
  const response = await apiClient.post("/GetNoOfLeaveWithDate", payload);
  
  return response;
};

export const GetTotalHeadCount = async (payload) => {
  const response = await apiClient.post("/GetTotalHeadCount", payload);
  return response; 
};

export const InsertEmpLeavreqByUser = async (payload) => {
  const response = await apiClient.post("/insertEmpLeaveRequestadmin", payload);
  return response;
};

export const insertEmpLeaveRequestadminWeeklyOff = async (payload) => {
  const response = await apiClient.post("/insertEmpLeaveRequestadminWeekOff", payload);
  return response;
};




export const GetLeavsAllemployesss = async (payload) => {
  const response = await apiClient.post("/GetEmpLeaveRequestadmin", payload);
  return response;
};

export const GetDetailedPFData = async (payload) => {
  const response = await apiClient.post("/GetDetailedPFData", payload);
  return response;
};


export const leaverequeststatuschange = async (payload) => {
  const response = await apiClient.post("/leaverequeststatuschange", payload);
  return response;
};


export const deletealocatedShift = async (payload) => {
  const response = await apiClient.post("/deleteAttendence", payload);
  return response;
};

export const unautheriseatttendance = async (payload) => {
  const response = await apiClient.post("/unautheriseatttendance", payload);
  return response;
};


export const ProcessPunch = async (payload) => {
  const response = await apiClient.post("/processpunch", payload);
  return response;
};

export const PunchRecordsProcess = async (payload) => {
  const response = await apiClient.post("/processpunchrecords", payload);
  return response;
};

export const  getEmpStatus = async (query) => {
  const response = await apiClient.get(`/getEmpType?UserId=${query}`); 
  return response;
};
export const  getLoanType = async (query) => {
  const response = await apiClient.get(`/getLoanType?UserId=${query}`); 
  return response;
};

export const InsertLoan = async (payload) => {
  const response = await apiClient.post("/insertloan", payload);
  return response;
};

export const  getLoan = async (query) => {
  const response = await apiClient.get(`/getLoan?UserId=${query}`); 
  return response;
};

export const  getLoanPaymentType = async (query) => {
  const response = await apiClient.get(`/getLoanPaymentType?UserId=${query}`); 
  return response;
};


export const deleteLoan = async (payload, query) => {
  const response = await apiClient.post(`/deleterow?UserId=${query}`, payload);
  return response;
};

export const GetempLoanData = async (payload) => {
  const response = await apiClient.post("/GetEmployeeLoanData", payload);
  return response;
};

export const getEmployeeNominees = async (payload) => {
  const response = await apiClient.post("/getEmployeeNominees", payload);
  return response;
};
export const RemoveNominee = async (payload) => {
  const response = await apiClient.post("/RemoveNominee", payload);
  return response; 
};

export const RemoveSpecialLeave = async (payload) => {
  const response = await apiClient.post("/RemoveSpecialLeave", payload);
  return response; 
};

export const ServiceBookRemove = async (payload) => {
  const response = await apiClient.post("/ServiceBookRemove", payload);
  return response;
};

export const RemoveAnnounceMent = async (payload) => {
  const response = await apiClient.post("/RemoveAnnounceMent", payload);
  return response;
};

export const rejectLateIndividual=async(payload)=>{
  const response= await apiClient.post('/rejectLateIndividual',payload)
  return response;
}


export const getrejectedLates = async (payload) => {
  const response = await apiClient.post("/getrejectedLates", payload);
  return response;
};



export const GetEmpLeaves = async (payload) => {
  const response = await apiClient.post("/GetEmpLeaves", payload);
  return response;
};

export const  getLoanwithDaterange = async (payload) => {
  const response = await apiClient.post("/getLoanwithDaterange?UserId",payload); 
  return response;
};

export const  getEmpLog = async (payload) => {
  const response = await apiClient.post("/GetEmployeeDataLog?UserId",payload); 
  return response;
};

export const GetEmployeeDataLogPdf = async (payload) => {
  const response = await apiClient.post(
    "/GetEmployeeDataLogPdf",
    payload,
    {
      responseType: "blob",
    }
  );

  return response;
};

export const GetEmployeeDataLogPdfLate = async (payload) => {
  const response = await apiClient.post(
    "/GetEmployeeDataLogPdfLate",
    payload,
    {
      responseType: "blob",
    }
  );

  return response;
};


export const insertEmpPayrollData = async (payload) => {
  const response = await apiClient.post("/insertPayrollData", payload);
  return response;
};   

export const InsertLoanBulk = async (payload) => {
  const response = await apiClient.post("/insertloanBulk", payload);
  return response;
};
export const InsertNominibulk = async (payload) => {
  
  const response = await apiClient.post("/InsertNominibulk", payload);
  
  return response;
};

export const InsertserviceBook = async (payload) => {

  const res = await apiClient.post("/insertservicebook", payload);
  return res;
};

export const InsertLoanObj = async (payload) => {
  const response = await apiClient.post("/InsertLoanObj", payload);
  return response
}
export const UnAuthorizePayroll = async (payload) => {
  const response = await apiClient.post("/UnAuthorizePayroll", payload);
  return response;
};  
export const insertUpdatedLeave = async (payload) => {
  const response = await apiClient.post("/insertUpdatedLeave", payload);
  return response;  
};

export const getPfData = async (payload) => {
  const response = await apiClient.post("/getPfData", payload);
  return response;
};

export const getEsiData = async (payload) => {
  const response = await apiClient.post("/getEsiData", payload);
  return response;
};


export const insertEditedInOut = async (payload) => {
  const response = await apiClient.post("/insertEditedInOut", payload);
  return response;
};

export const getEditReport = async (payload) => {
  const response = await apiClient.post("/GetEmployeeDataLogByDateRange", payload);
  return response;
};

export const ProcessEmpLeave = async (payload) => {
  const response = await apiClient.post("/ProcessEmpLeave", payload);
  return response;
};

export const ProcessEmpLeaveALL = async (userId) => {
  const response = await apiClient.get(`/ProcessEmpLeaveALL?UserId=${userId}`);
  return response;
};


export const changeRequestStatus = async (payload) => {
  const response = await apiClient.post("/changeRequestStatus", payload);
  return response;
};

export const TrackAutheriseLog = async (payload) => {
  const response = await apiClient.post("/trackAutheriseLog", payload);
  return response;
};

export const getServiceRequest = async (query) => {
  const response = await apiClient.get(`/ServiceRequest?UserId=${query}`);
  return response;

}

export const getUsersForLeaval = async (query) => {
  const response = await apiClient.get(`/getUsersForLeaval?UserId=${query}`);

  return response;
};
